import { useEffect } from 'preact/compat'
import { useSelector } from 'react-redux'
import { redirect, getAbsoluteUrl } from '../helpers/common'
import { DataDog } from '../datadog'

export default function useFailureRedirect() {
  const transactionDetails = useSelector(state => state.transactionDetails)
  const paymentResponse = useSelector(state => state.paymentResponse)
  const { errorCode, errorMessage, hasError, isRetryable } = paymentResponse
  const { failureUrl } = transactionDetails
  const handleRedirect = () => {
    let url
    try {
      url = new URL(failureUrl)
    } catch (_) {
      // in case we have relative url
      url = new URL(getAbsoluteUrl(failureUrl))
    }

    if (errorCode) {
      url.searchParams.append('errorCode', errorCode)
    }

    if (errorMessage) {
      url.searchParams.append('errorMessage', errorMessage)
    }
    DataDog.info(
      `Redirection. useFailureRedirect, redirect url: ${url.toString()}`
    )
    redirect(url.toString())
  }

  useEffect(() => {
    if (hasError && failureUrl && !isRetryable) {
      handleRedirect()
    }
  }, [hasError, isRetryable])
}
